import { atom, selector } from "recoil";
import { CompanyRequest, CompanyRequestTouched } from "../types/companies";
import {
  COMPANY_DEFAULTS,
  COMPANY_TOUCHED_DEFAULTS,
} from "../constants/companies";

export const editCompanyState = atom<CompanyRequest>({
  key: "app.company.edit",
  default: COMPANY_DEFAULTS,
});

export const editCompanyTouchedState = atom<CompanyRequestTouched>({
  key: "app.company.edit.touched",
  default: COMPANY_TOUCHED_DEFAULTS,
});

export const editCompanyValidState = selector<{
  [key in keyof CompanyRequest]: boolean;
}>({
  key: "app.company.edit.valid",
  get: ({ get }) => {
    const fields = get(editCompanyState);

    // SET ALL FIELDS TO BE VALID
    const validFields = Object.fromEntries(
      Object.keys(fields).map((key) => [key, true])
    ) as {
      [key in keyof CompanyRequest]: boolean;
    };

    // VALIDATE REQUIRED FIELDS
    if (!fields.name) {
      validFields.name = false;
    }

    return validFields;
  },
});

export const editCompanyErrorState = selector({
  key: "app.company.edit.error",
  get: ({ get }) => {
    const validFields = get(editCompanyValidState);
    return Object.values(validFields).some((valid) => !valid);
  },
});
